module.exports = __webpack_public_path__ + "assets/img/Teaser_Claim_RGB.28924d93.jpg";